import React from 'react'

// components
import FormDataPoint from '../../../../../components/forms/FormDataPoint/FormDataPoint.component'

// graphql
import { useQuery } from '@apollo/client'
import { GET_JOB_DAY_BY_ID_JOB_INFO_FOR_PROCESS_TIME_TICKETS } from '../../../../../graphql/jobDay/jobDay.queries'

export default function JobInfo({ jobDayId }) {

    const { data } = useQuery(GET_JOB_DAY_BY_ID_JOB_INFO_FOR_PROCESS_TIME_TICKETS, {
        variables: { id: parseInt(jobDayId, 10) }
    })

    let job = {}

    if(data && data.jobDay) {
        job = {...data.jobDay.job}
    }

    return (<div>

        <FormDataPoint label='Job' value={[job.name]} />
        <FormDataPoint label='Address' value={[job.street1 ? job.street1 : '', job.street1 ? `${job.city}, ${job.state} ${job.zipcode}` : '']} />
        <FormDataPoint label='Customer' value={[job.customerName]} />
        <FormDataPoint label='Contact' value={[job.customerContactName]} />
        <FormDataPoint label='Contact Phone #' value={[job.customerPhone]} />

    </div>)
}